import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { InputType } from 'config'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getAdminConfig, setAdminConfig } from 'services'
import { RenderInput } from 'utils/RenderInput'

const BORROWER_PROFILE = 'borrower'

export const SwitchUserVisibility = () => {
  const [loading, setLoading] = useState(false)
  const [profiles, setProfiles] = useState<Record<string, string>>({})
  const [visibility, setVisibility] = useState<Record<string, string[]>>({})
  const [changed, setChanged] = useState(false)

  const initData = async () => {
    setLoading(true)
    const data = await getAdminConfig('userSwitchVisibility')
    setProfiles(data?.profiles || {})
    setVisibility(data?.visibility || {})
    setLoading(false)
    setChanged(false)
  }

  useEffect(() => {
    initData()
  }, [])

  const viewerKeys = Object.keys(profiles)
    .filter((key) => key !== BORROWER_PROFILE)
    .sort((a, b) => (profiles[a] || a).localeCompare(profiles[b] || b))

  const onChange = (viewer: string, value: string[]) => {
    const next = cloneDeep(visibility)
    next[viewer] = value
    setVisibility(next)
    setChanged(true)
  }

  const onSubmit = async () => {
    setLoading(true)
    const saved = await setAdminConfig('userSwitchVisibility', visibility)
    setProfiles(saved?.profiles || profiles)
    setVisibility(saved?.visibility || visibility)
    toast('Successfully submitted', { type: 'success' })
    setLoading(false)
    setChanged(false)
  }

  return (
    <div className="relative px-3 py-1.5">
      <LayoutLoading show={loading} />
      <div className="text-xl font-bold mb-2">Switch User Visibility</div>
      <p className="text-sm text-gray-600 mb-4 max-w-3xl">
        Choose which profiles each profile can switch into. The direction is one way: servicing can include processor
        while processor leaves servicing off. A person who holds several profiles can switch into the combined list.
        Account executives, brokers, and branches are still limited to their own organization. Borrower is an active
        Manage Borrowers account. Saving stores this list; until then, switch user keeps its current staff reach and
        also includes active borrowers.
      </p>
      {viewerKeys.map((viewer) => {
        const input: InputType = {
          inputType: 'multiselect',
          title: `${profiles[viewer]} can switch into`,
          options: profiles,
          sort: true,
          defaultSelected: false,
          value: visibility[viewer] || [],
        }
        return (
          <div className="mb-2" key={viewer}>
            <RenderInput input={input} Key={viewer} onChange={(_key: string, value: any) => onChange(viewer, value)} />
          </div>
        )
      })}
      <SaveChanges show={changed} onSave={onSubmit} />
    </div>
  )
}
